import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, MaxLengthValidator } from '@angular/forms';
import { SampleSearchService, accessionNoValidation, accessionNoAndContainerValidation } from '../../shared/samples-search/sample-search-service';
import { maxLengthInBytes } from '../../../shared/validators';
import { SampleTrackingStorage } from '../../sample-tracking-storage';
import { Observable } from 'rxjs';
import { UrlBuilder } from '../../../core';

@Component({
    selector: 'app-dashboard-search',
    template: require('./dashboard-search.component.html'),
    styles: [require('./dashboard-search.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppDashboardSearchComponent {

    @Input()
    public searchList: { id: number, value: string}[] = [
        { id: 1, value: 'Search by Accession' },
        { id: 3, value: 'Search by Patient Number' },
        { id: 2, value: 'Search by Sample' },
    ];
    public searchControl: FormControl = new FormControl('');
    public searchControlId: string;
    public searchLabel: string;
    public showLoading: boolean;
    public searchError: string;
    public maxLength: number;

    public selectedSearch = 0;

    @Output()
    public onSubjectSearch: EventEmitter<string> = new EventEmitter();

    constructor(
        private sampleSearchService: SampleSearchService,
        private sampleTrackingStorage: SampleTrackingStorage,
        private urlBuilder: UrlBuilder,
        private changeDectRef: ChangeDetectorRef
    ) {
        this.searchControl.valueChanges.subscribe(() => { this.searchError = ''; this.changeDectRef.markForCheck(); });
    }

    public onSearchContextSelect(item: { id: number, value: string }[]) {
        if (!item || item.length === 0) { return; }
        this.selectedSearch = item[0].id;
        this.resetValue();
        if (this.selectedSearch === 1) {
            this.searchControl.setValidators(accessionNoValidation());
            this.searchLabel = 'Type Accession';
            this.searchControlId = 'searchForVisit';
            this.maxLength = 10;
        } else if (this.selectedSearch === 2) {
            this.searchControl.setValidators(accessionNoAndContainerValidation());
            this.searchLabel = 'Type Barcode Number';
            this.searchControlId = 'searchForSample';
            this.maxLength = 14;

        } else {
            this.searchControl.setValidators(maxLengthInBytes(15));
            this.searchLabel = 'Type Patient Number';
            this.searchControlId = 'searchForSubjectID';
            this.maxLength = 15;

        }
    }

    public search($event: any) {
        if (this.selectedSearch === 1 && this.searchControl.valid) {
            this.onVisitSearchClick();
        }
        if (this.selectedSearch === 2 && this.searchControl.valid) {
            this.onSampleSearchClick();
        }
        if (this.selectedSearch === 3 && this.searchControl.valid) {
            if (!this.searchControl.value) {
                this.searchError = 'Enter valid Patient Number to search.';
                this.changeDectRef.markForCheck();
                return;
            }
            this.onSubjectSearch.emit(this.searchControl.value);
        }
    }

    public onVisitSearchClick() {
        this.searchError = '';

        if (!this.searchControl.value.trim()) {
            this.searchError = 'Enter valid Accession to search.';
            return;
        }
        this.showLoading = true;
        this.sampleTrackingStorage.getSampleSearch(this.searchControl.value.trim())
            .subscribe(result => {
                if (!result.isError) {
                    this.sampleTrackingStorage.sampleSearchData = new Observable(ob => ob.next(result.accessionContainerData));
                    this.urlBuilder
                        .esa()
                        .sampletracking()
                        .visitDetails()
                        .navigate();
                } else {
                    this.searchError = result.errorMsg;
                }
                this.showLoading = false;
                this.changeDectRef.markForCheck();
            });
    }

    public onSampleSearchClick() {

        this.searchError = '';

        const sampleSearchValue = this.searchControl.value.replace('-', '').trim();

        if (!sampleSearchValue) {
            this.searchError = 'Accession and Container No cannot be empty.';
            return;
        }

        let accessionNo = '';
        let containerNo = 0;

        ({ accessionNo, containerNo } = this.sampleSearchService.getAccessionAndContainerNo(sampleSearchValue, accessionNo, containerNo));

        const containerNoValidationMsg = this.sampleSearchService.validateContainerNo(containerNo);

        if (containerNoValidationMsg) {
            this.searchError = containerNoValidationMsg;
            return;
        }

        this.showLoading = true;
        this.sampleTrackingStorage.getSampleSearch(accessionNo, containerNo)
            .subscribe(result => {
                if (!result.isError) {
                    this.sampleTrackingStorage.sampleSearchData = new Observable(ob => ob.next(result.accessionContainerData));
                    this.urlBuilder
                        .esa()
                        .sampletracking()
                        .sampleDetails(containerNo)
                        .navigate();
                } else {
                    this.searchError = result.errorMsg;
                }
                this.showLoading = false;
                this.changeDectRef.markForCheck();
            });
    }

    public resetValue() {
        this.searchControl.setValue('');
    }
}